'use client';

import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';

type Props = {
  businessId: string;
} & PropsWithChildren;

const BusinessIdContext = createContext<{
  businessId: string;
  onChangeBusinessId: (businessId: string) => void;
} | null>(null);

export const useBusinessId = () => {
  const context = useContext(BusinessIdContext);
  if (!context) {
    throw new Error('useBusinessId must be used within a BusinessIdProvider');
  }
  return context;
};

export function BusinessIdProvider({
  children,
  businessId: busienssIdFromCookie,
}: Props) {
  const [businessId, onChangeBusinessId] = useState(
    busienssIdFromCookie ?? '-1',
  );
  // const contextValue = useMemo(() => {
  //   return {
  //     businessId,
  //     onChangeBusinessId,
  //   };
  //   // TODO - businessId가 없는 경우에 대한 예외처리 추가 - buyer api 호출하여 businessId 가져와서 비교
  // }, [businessId]);

  useEffect(() => {
    // 타 탭에서 businessID를 변경할 경우 앱에서 changePublicBusinessId() 이벤트를 호출함
    const onChangePublicBusinessId = (e: CustomEvent<{ name: string }>) => {
      if (e?.detail?.name) {
        onChangeBusinessId(e.detail.name);
      }
    };

    window.addEventListener('changePublicBusinessId', onChangePublicBusinessId);

    return () => {
      window.removeEventListener(
        'changePublicBusinessId',
        onChangePublicBusinessId,
      );
    };
  }, []);

  return (
    <BusinessIdContext.Provider
      value={{
        businessId,
        onChangeBusinessId,
      }}
    >
      {children}
    </BusinessIdContext.Provider>
  );
}
